import { render, staticRenderFns } from "./CrearCliente.vue?vue&type=template&id=6caa0317&"
import script from "./CrearCliente.vue?vue&type=script&lang=ts&"
export * from "./CrearCliente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports